module.exports = __webpack_public_path__ + "static/media/overview_bg.a099502c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/branding/advoco/overview_bg.jpg
// module id = 1108
// module chunks = 0